import { render, staticRenderFns } from "./TableDetail.vue?vue&type=template&id=3027df7a&scoped=true&"
import script from "./TableDetail.vue?vue&type=script&lang=js&"
export * from "./TableDetail.vue?vue&type=script&lang=js&"
import style0 from "./TableDetail.vue?vue&type=style&index=0&id=3027df7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3027df7a",
  null
  
)

export default component.exports